import HTTP from '@/plugins/http';

const ordersApi = {
  merchantData: '/merchant/list',
  merchantDataNew: '/admin/list',
  channelTypeData: '/channel/type',
  tableData: '/orderRecord/list/page',
  totalData: '/orderRecord/count',
  export: '/orderRecord/export',
  callback: '/orderRecord/manual/callback',
  manual: '/orderRecord/manual/makeup',
  cardPcManual: '/orderRecord/updateCardOrder'
};

/**
 *
 * @param {{
 *  submitTime: string
 *  merchatNo: string
 *  agentNo: string
 *  merchatOrderNo: string
 *  systemOrderNo: string
 *  channelType: string
 *  callbackStatus: string
 *  orderStatus: string
 *  description: string
 *  amountStart: string
 *  amountEnd: string
 * }} parameter
 * @returns {*}
 */
function handleExport(parameter) {
  return HTTP.loading({
    url: ordersApi.export,
    method: 'post',
    data: parameter,
    responseType: 'blob',
    timeout: 600000
  });
}

/**
 * 商户列表
 * @param {*} parameter
 * @returns {*}
 */
function getMerchantData({ data }) {
  return HTTP({
    url: ordersApi.merchantData,
    method: 'post',
    data
  });
}

function getMerchantDataNew({ data }) {
  return HTTP({
    url: ordersApi.merchantDataNew,
    method: 'post',
    data
  });
}

/**
 * 获取订单渠道类型
 * @param {*} parameter
 * @returns {*}
 */
function getChannelTypeData(parameter) {
  return HTTP({
    url: ordersApi.channelTypeData,
    method: 'get',
    data: parameter
  });
}

function getTableData({ data, params }) {
  return HTTP({
    url: ordersApi.tableData,
    method: 'post',
    data,
    params
  });
}
function getTotalData(parameter) {
  return HTTP({
    url: ordersApi.totalData,
    method: 'post',
    data: parameter
  });
}

function getCallback(params) {
  return HTTP.loading({
    url: ordersApi.callback,
    method: 'get',
    params
  });
}

function getManual(params) {
  return HTTP.loading({
    url: ordersApi.manual,
    method: 'get',
    params
  });
}

function getCardPcManual(params) {
  return HTTP({
    url: ordersApi.cardPcManual,
    method: 'post',
    data: params
  });
}

export default {
  handleExport,
  getMerchantData,
  getChannelTypeData,
  getTableData,
  getTotalData,
  getCallback,
  getManual,
  getMerchantDataNew,
  getCardPcManual
};



// WEBPACK FOOTER //
// ./src/api/orders.js